import { ReactToExerciseEventType, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level2.json";

const Level2: Tutorial = {
  end: '2:14',
  level: 2,
  videoUrl: 'level-2.mp4',
  sections: [
    {
      chapters: [
        {
          start: '0:0',
          title: 'D in the Treble Clef',
          data: [ChapterType.Lecture],
        },
        {
          start: '0:20',
          title: 'D on the Keyboard',
          data: [ChapterType.Lecture],
        },
        {
          start: '0:31',
          title: 'Find D',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play D on your keyboard.',
                      target: 'D4',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
      ],
    },
    {
      chapters: [
        {
          title: 'Finger Numbers',
          start: '0:38.5',
          data: [ChapterType.Lecture],
        },
        {
          title: 'Playing D',
          start: '0:54',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  padding_x: 230,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
        {
          start: '1:11',
          title: 'Playing with the 2nd Finger',
          data: [ChapterType.Lecture],
        },
        {
          start: '1:45',
          title: 'Playing C and D',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  objectives: [
                    {}
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
        {
          start: '2:01',
          title: 'Playing in Time',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  objectives: [
                    {
                      tempo: 72,
                      videoCompleteDestination: '2:06',
                      videoSkipDestination: '2:07',
                    },
                    {
                      tempo: 72,
                      videoCompleteDestination: '2:10.5',
                      videoSkipDestination: '2:12',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        },
      ],
    },
  ],
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level2);

